// extracted by mini-css-extract-plugin
export default {"brand-store":"BrandStore_brand-store__pcFb3"};